export class CreateAffiliateUrlResponse {
    message?: string;
    isSuccess: boolean = false;
    shortenUrl?: string;
    httpStatusCode?: number;
}
